/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIEventEnum } from './APIEventEnum';
import {
    APIEventEnumFromJSON,
    APIEventEnumFromJSONTyped,
    APIEventEnumToJSON,
} from './APIEventEnum';

/**
 * API request serializer for test endpoint to get latest token.
 * Used for OpenAPI schema generation.
 * @export
 * @interface APIAPITestGetLatestTokenRequestRequest
 */
export interface APIAPITestGetLatestTokenRequestRequest {
    /**
     * The user's email address
     * @type {string}
     * @memberof APIAPITestGetLatestTokenRequestRequest
     */
    email: string;
    /**
     * Optional event type filter (SIGNUP, INVITE, VERIFICATION, RESET_PASSWORD). If not provided, returns the latest token of any type.
     * @type {APIEventEnum}
     * @memberof APIAPITestGetLatestTokenRequestRequest
     */
    event?: APIEventEnum;
}



/**
 * Check if a given object implements the APIAPITestGetLatestTokenRequestRequest interface.
 */
export function instanceOfAPIAPITestGetLatestTokenRequestRequest(value: object): value is APIAPITestGetLatestTokenRequestRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function APIAPITestGetLatestTokenRequestRequestFromJSON(json: any): APIAPITestGetLatestTokenRequestRequest {
    return APIAPITestGetLatestTokenRequestRequestFromJSONTyped(json, false);
}

export function APIAPITestGetLatestTokenRequestRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIAPITestGetLatestTokenRequestRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'event': json['event'] == null ? undefined : APIEventEnumFromJSON(json['event']),
    };
}

export function APIAPITestGetLatestTokenRequestRequestToJSON(value?: APIAPITestGetLatestTokenRequestRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'email': value['email'],
        'event': APIEventEnumToJSON(value['event']),
    };
}

